import { RemoteAddMeters } from "../../../../data/usecases/meter";
import { AddMeters } from "../../../../domain/usecases/add-meters";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAddMeters = (): AddMeters =>
  new RemoteAddMeters(makeApiUrl("/meters/add-meters"), makeAxiosHttpClient());
